import * as THREE from 'three';

// Loads the fairground at night tools/build-fairground.mjs cut into bulbs - the picture
// with its bulbs off, the light every bulb adds (diff), the lossless id map
// and the per-bulb data - once, at startup, for visualizers/fairground.js.
// Same preload/get shape as rosace-assets.js, and the same rule: the preload
// is a WIRING POINT every entry point must call (main, main-radio,
// main-embedded, play-boot, landing-boot, demo-boot, the capture harness).
// A forgotten one is silent: the getter returns null and the fair stays
// dark.
//
// THE ID MAP IS DATA, NOT A PICTURE: NearestFilter, no mipmaps, no colour
// space. The two photographs are sRGB and decoded by the GPU, which is what
// lets the shader add them in linear light.
const MANIFEST_URL = 'textures/fairground.json';

let _assets = null;
let _promise = null;

function loadTexture(url, configure) {
  return new Promise(function (resolve, reject) {
    new THREE.TextureLoader().load(url, function (t) { configure(t); t.needsUpdate = true; resolve(t); }, undefined, function () {
      reject(new Error(url + ' failed to load'));
    });
  });
}

// No mipmaps: the pictures are shown at about their own size, and a mip
// blend over the bulbs lifted the whole frame by 2/255 against
// alley-on (measured through the harness; 0.7/255 without it).
function photo(t) {
  t.colorSpace = THREE.SRGBColorSpace;
  t.generateMipmaps = false;
  t.minFilter = THREE.LinearFilter;
  t.magFilter = THREE.LinearFilter;
  t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
}

export function preloadFairground() {
  if (_promise) return _promise;
  _promise = fetch(MANIFEST_URL)
    .then(function (r) {
      if (!r.ok) throw new Error('fairground.json HTTP ' + r.status);
      return r.json();
    })
    .then(function (manifest) {
      return Promise.all([
        loadTexture('textures/' + manifest.off, photo),
        loadTexture('textures/' + manifest.diff, photo),
        loadTexture('textures/' + manifest.ids, function (t) {
          t.colorSpace = THREE.NoColorSpace;
          t.generateMipmaps = false;
          t.minFilter = THREE.NearestFilter;
          t.magFilter = THREE.NearestFilter;
          t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
        }),
        fetch('textures/' + manifest.data).then(function (r) {
          if (!r.ok) throw new Error(manifest.data + ' HTTP ' + r.status);
          return r.json();
        })
      ]).then(function (parts) {
        _assets = { manifest: manifest, off: parts[0], diff: parts[1], ids: parts[2], data: parts[3] };
        return _assets;
      });
    })
    .catch(function (err) {
      console.error('[party-mode] fairground assets unavailable, Fairground will not be offered', err);
      _assets = null;
      return null;
    });
  return _promise;
}

export function getFairground() {
  return _assets;
}

// Node tests only: hand in assets without a fetch.
export function _setFairgroundForTests(a) { _assets = a; _promise = Promise.resolve(a); }
